<div class="form-input-container" [style]="style">
  @if (!readonly) {
    <label>{{label}}</label>
    <input [style.width]="control_width_pct" [style.height]="control_height_px" type="date" #inputControl [value]="boundValue || ''" (input)="_handle_change($event)" (blur)="_handle_onBlur($event)"/>

  }

  @if (readonly) {
    <label>{{label}}</label>
    <input [readonly]="true" [style.width]="control_width_pct" [style.height]="control_height_px" type="date" #inputControl [value]="boundValue || ''" (input)="_handle_change($event)" (blur)="_handle_onBlur($event)"/>
  }
</div>